var map = {
	"./abdomen.png": "6a40",
	"./antebraco-d.png": "9824",
	"./antebraco-e.png": "52c3",
	"./braco-d.png": "fdc5",
	"./braco-e.png": "7efa",
	"./cintura.png": "ff3e",
	"./coxa-distal-d.png": "4138",
	"./coxa-distal-e.png": "bac6",
	"./coxa-media-d.png": "8eff",
	"./coxa-media-e.png": "2e11",
	"./deltoides.png": "da63",
	"./empty.png": "a20a",
	"./panturrilha-d.png": "c9c8",
	"./panturrilha-e.png": "717e",
	"./pescoco.png": "15b5",
	"./quadril.png": "8838",
	"./torax.png": "b6b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3863";